import { render, staticRenderFns } from "./item-file.vue?vue&type=template&id=7f826c9d&scoped=true"
import script from "./item-file.vue?vue&type=script&setup=true&lang=js"
export * from "./item-file.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-file.vue?vue&type=style&index=0&id=7f826c9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f826c9d",
  null
  
)

export default component.exports